<template>
  <BaseNoticeItem>
    <template #head>
      <strong>{{ $t('This hire is missing a contract type') }}</strong>
    </template>
    <template #body>
      {{ $t('The final contract type for this job is pending.') }}
      {{
        $t(
          'You will be able to accept the hire and create bills once a contract type has been set.',
        )
      }}
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()
</script>
